import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

/** Календарь на всю ширину сверху, под ним матчи выбранного дня; страница прокручивается целиком. */
export const MainBlock = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  width: 100%;
`;

export const GamesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  padding-bottom: 4px;

  &::-webkit-scrollbar {
    width: 4px;
    background-color: inherit;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.SurfacePlatinum20};
    border-radius: 8px;
  }
`;

export const GamesList = styled.div`
  &:not(:first-of-type) {
    .ChampionshipHeader {
      border-radius: 8px 8px 0 0;
    }
  }
`;

export const ChampionshipHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;

  background-color: white;
  border-bottom: 1px ${theme.colors.SurfacePlatinum20} solid;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

/**
 * Матчи выбранного дня. Появляются проявлением, без сдвига — это длинный список, двигать его нельзя; перед ним
 * ставят `key` дня, и при смене дня блок проявляется заново. Данные при этом уже на месте: анимация ответа не задерживает.
 */
export const DayMatches = styled.div`
  overflow: hidden;
  animation: ${fadeIn} 0.18s ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
